<ppstb-main-s1
  [form]="form"
  [showAmendment]="showAmendment"
  (formCreated)="formCreated.emit($event)"
  (formCancelled)="formCancelled.emit($event)"
></ppstb-main-s1>
<div
  *ngIf="
    form?.id &&
    (form?.formVersion?.statusID ?? 0) != formStatusEnum.New &&
    form?.formVersion?.statusID != formStatusEnum.Draft
  "
>
  <ppstb-main-s2 [form]="form" [service]="service"></ppstb-main-s2>

  <ppstb-main-s3 [form]="form" [service]="service"></ppstb-main-s3>
  <div class="container-fluid">
    <worker-verification-table
      [currentDocument]="{
        id: form?.id ?? 0,
        type: formTypeEnum.PPSTB,
        status: form?.formVersion?.statusID ?? 0,
      }"
      [privilegeToSign]="privilegeEnum.Worker"
    ></worker-verification-table>
    <!-- US 6921: PPSTB signs with the Worker privilege like SCF/RSSWA, so allowed roles show and holders can sign.
         Keyed by Form ID (not FormVersion ID) to match the Documents view used by the signing log, and to keep signatures across amendments. -->

  </div>
  <ppstb-main-s4 [form]="form" [service]="service"></ppstb-main-s4>
  <ppstb-main-s5 [form]="form" [service]="service"></ppstb-main-s5>
  <ppstb-main-s6 [form]="form" [service]="service"></ppstb-main-s6>
  <ppstb-main-s7 [form]="form" [service]="service"></ppstb-main-s7>
  <ppstb-main-s8 [form]="form" [service]="service"></ppstb-main-s8>

  <div class="container-fluid mt-4">
    <comments-and-attachments
      *ngIf="form"
      headerClass="h5"
      id="Section5Title"
      [currentDocument]="{
        status: form.formVersion.statusID,
        serialNo: form.sequenceNumber.number,
        type: formTypeEnum.PPSTB,
      }"
    >
    </comments-and-attachments>
  </div>
</div>
